import { getAppConfig } from '@services/config';

import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { HttpProxyAgent } from 'http-proxy-agent';
import { HttpsProxyAgent } from 'https-proxy-agent';

const config = getAppConfig();

export function axiosInstanceFactory(external = false): AxiosInstance {
    const proxy = config.proxy.url;

    const axiosConfig: AxiosRequestConfig = {};

    if (external && proxy) {
        axiosConfig.proxy = false;
        axiosConfig.httpAgent = new HttpProxyAgent(proxy);
        axiosConfig.httpsAgent = new HttpsProxyAgent(proxy);
    }

    const defaultAxiosInstance = axios.create(axiosConfig);

    return defaultAxiosInstance;
}
